<template>
  <div>
    <OverlayPanel
      :ref="'op'"
      @click="toggle"
      appendTo="body"
      :showCloseIcon="true"
      id="overlay_panel"
      style="width: 700px"
    >
      <Button style="float: left;" label="View Customer" icon="pi pi-search" @click="viewCustomer"/>
      <Button style="float: right;" label="View Full History" icon="pi pi-inbox" @click="viewFullHistory"/>
      <br />
      <br />
      <HistoryTable
        :data="customerHistory"
        :name="'Customer History'"
        :loading="customerHistoryLoading"
        :customer="tempCustomer"
      />
    </OverlayPanel>

    <DataTable 
      :value="data" 
      :loading="loading"
      rowGroupMode="subheader" 
      :groupRowsBy="groupedOnColumn.colField"
      sortMode="single" 
      :sortField="groupedOnColumn.colField" 
      :sortOrder="1" 
      :expandableRowGroups="true"
      :expandedRowGroups.sync="expandedRowGroups"
      @rowExpand="onRowExpand"
      @rowCollapse="onRowCollapse"
      :resizableColumns="true" 
      columnResizeMode="expand"
      @column-resize-end="colsResized"
    >
      <Column 
        v-for="(col, index) in colSelectedFieldsForTable" 
        :key="index"
        :field="col.colField" 
        :header="col.colName" 
        :sortable="col.canSort"
        :headerStyle="'width: ' + col.colWidth + 'px; height: 41px; border-width: 0px;'"
        bodyStyle="border-right-width: 0px;; border-left-width: 0px;"
      >
        <template #body="slotProps">
          <div
            style="height: 40px; padding: 10px 0px;"
            @click="openOP(slotProps.data, col, $event)"
            :class="getStyle1(slotProps.data, col)"
          >
            {{ getToShow(slotProps.data, col) }}
          </div>
        </template>
      </Column>
      <template #groupheader="slotProps">
        <span>
          <strong style="margin-right: 200px;">{{ getGroupName(slotProps.data, groupedOnColumn) }}</strong>
          <span>{{ calculateRecordsTotal(slotProps.data, groupedOnColumn.colField) }}</span>
        </span>
      </template>
      <template #groupfooter="slotProps">
        <td
          v-for="(col, index) in colSelectedFieldsForTableWithoutGroupedOnColumn" 
          :key="index + reloadGroupFooters"
          :style="getRecordsSum(slotProps.data, col) ? null : 'border-bottom-width: 5px;'"
          :class="getRecordsSum(slotProps.data, col) ? 'sum-present' : null"
        >
          <span>{{ getRecordsSum(slotProps.data, col) }}</span>
        </td>
      </template>
      <template #footer>
        <div
          style="width: 100%; position: relative; overflow-x: scroll; height: 100px;"
        >
          <span
            v-for="(i, index) in sumSentences"
            :key="index"
            :style="getFooterPosition(i)"
          >
            {{ i.text }}
          </span>
        </div>
      </template>
    </DataTable>
          
  </div>
</template>

<script>
import { formatCurrency } from '@/utils/money'
import CustomerService from "@/service/CustomerService"
import ReportsService from "@/service/ReportsService";

import HistoryTable from '../customer/customerHistoryTable'

export default {
  components: {
    HistoryTable
  },
  created() {
    this.data = []
    this.setupComponent()
  },
  mounted() {
    setTimeout(() => {
      this.setBordersOfSumsRow()
    }, 100)
  },
  updated() {
    setTimeout(() => {
      this.setBordersOfSumsRow()
    }, 100)
  },
  props: [
    'reports',
    'dbViewFields',
    'groups',
    'colSelectedFieldsForTable',
    'dbViewFieldsForQuickFilters',
    'quickFiltersSelection',
    'datesFrom',
    'datesTo',
    'searchText',
    'reloadData',
    // Report-specific filters that are not driven by the generic quick-filter
    // dropdowns - currently the duplicate reports' Active/All toggle. Merged into the
    // request body as-is.
    'extraFilters'
  ],
  data: () => ({
    customerService: new CustomerService(),
    reportsService: new ReportsService(),
    data: [],
    loading: false,
    groupSums: [],
    sum: 0,
    count: 0,
    groupedOnColumn: {},
    groupedOnColumnIndex: {},
    sumSentences: [],
    allGroupTypes: [],
    expandedRowGroups: [],
    colSelectedFieldsForTableWithoutGroupedOnColumn: [],
    
    tempCustomer: {},
    customerHistory: [],
    customerHistoryLoading: false,

    reloadGroupFooters: 0,
    thisReport: {},
    reportIndexForStore: null,

    currentPage: 1,
    rows: 100000
  }),
  computed: {
    routeId() {
      return this.$route.params.id
    },
    allReports() {
      return this.$store.getters['reports/getAllReports']
    },
  },
  watch: {
    dbViewFields(val) {
      // 
      this.setupComponent()
    },
    reports(val) {
      // 
      this.data = []
      this.setupComponent()
    },
    groups(val) {
      // console.dir(val)
      this.setupComponent()
    },
    searchText(val) {
      this.data = []
      this.setupComponent()
    },
    reloadData(val) {
      this.data = []
      this.setupComponent()
    },
    extraFilters: {
      handler() {
        this.data = []
        this.setupComponent()
      },
      deep: true
    }
  },
  methods: {
    setupComponent() {
      

      this.sumSentences = []

      if (this.dbViewFields && this.dbViewFields[0]) {

        for (let h = 0; h < this.groups.length; h++) { // IT WILL ONLY RUN FOR THE FIRST 'TRUE' VALUE
          if (this.groups[h] && this.dbViewFields[h]) {
            this.groupedOnColumnIndex = h
            this.groupedOnColumn = this.dbViewFields[h]
            break
          }
        }

      }

      if (this.data && this.data[0]) {
        this.setupComponentData()

      } else {
        if (this.reports && this.reports[0]) {

          this.data = [...this.reports]
          this.setupComponentData()

        } else {
          let toCompare = parseInt(this.routeId)
          this.reportIndexForStore = this.allReports.findIndex(a => a.id === toCompare)
          this.thisReport = this.allReports[this.reportIndexForStore]

          
          let quickFilters = {}, searchText = '*'
          // 

          if (this.groupedOnColumn && this.groupedOnColumn.id) {
            quickFilters.groupedOn = this.groupedOnColumn.id
          }

          if (this.searchText) {
            searchText = this.searchText
          }

          if (
            !(
              this.quickFiltersSelection.every(element => !element) &&
              this.datesFrom.every(element => element === undefined || element === null) &&
              this.datesTo.every(element => element === undefined || element === null)
            )
          ) {

            if (this.dbViewFieldsForQuickFilters.length) {

              for (let i = 0; i < this.dbViewFieldsForQuickFilters.length; i++) {
                try {
                  if (this.dbViewFieldsForQuickFilters[i].filterDropdown) {
                    
                    
                    let a = this.dbViewFieldsForQuickFilters[i].colField.split('.').slice(0)[0];
                    let b = this.dbViewFieldsForQuickFilters[i].colField.split('.').slice(-1)[0];

                    if (this.quickFiltersSelection[i]) {
                      
                      if (this.dbViewFieldsForQuickFilters[i].colType === 'Date') {
                        // 

                        if (this.quickFiltersSelection[i].dateModifierFunc === "custom") {
                          // 
                          if (this.datesFrom[i]) {
                            try {
                              quickFilters[`${a}From`] = moment(this.datesFrom[i], "DD/MM/YYYY").format("YYYY/MM/DD")
                            } catch(e) {
                              quickFilters[`${a}From`] = this.datesFrom[i]
                            }
                          }
                          if (this.datesTo[i]) {
                            try {
                              quickFilters[`${a}To`] = moment(this.datesTo[i], "DD/MM/YYYY").format("YYYY/MM/DD")
                            } catch(e) {
                              quickFilters[`${a}To`] = this.datesTo[i]
                            }
                          }
                        } else {
                          quickFilters[a] = this.quickFiltersSelection[i].dateModifierFunc
                        }
                        
                      } else {
                        // 
                        if (this.quickFiltersSelection[i][b] === 'Yes') {
                          quickFilters[a] = true
                        } else if (this.quickFiltersSelection[i][b] === 'No') {
                          quickFilters[a] = false
                        } else {
                          // 
                          if (typeof this.quickFiltersSelection[i] === 'string') {
                            quickFilters[a] = this.quickFiltersSelection[i]
                          } else {
                            quickFilters[a] = this.quickFiltersSelection[i][this.dbViewFieldsForQuickFilters[i].filterFldId]
                          }
                        }

                      }
                    } else if (this.datesFrom[i] || this.datesTo[i]) {
                      if (this.dbViewFieldsForQuickFilters[i].colType === 'Currency' || this.dbViewFieldsForQuickFilters[i].colType === 'Number') {
                        // 
                        quickFilters[`${a}From`] = this.datesFrom[i]
                        quickFilters[`${a}To`] = this.datesTo[i]
                      }
                    }
                  }
                } catch(e) {
                  
                  continue
                }
              }
            }
            
          }

          if (this.extraFilters) {
            quickFilters = { ...quickFilters, ...this.extraFilters }
          }

          this.loading = true

          this.reportsService
            .getReportData(this.thisReport.reportEP, this.currentPage, this.rows, 0, 0, searchText, quickFilters)
            .then(response => {
              

              let a = response.config.url.split('/'), b = a.map(c => parseInt(c))

              

              

              if (a[6] === "*" && this.searchText === '' && b[2] === this.currentPage && b[3] === this.rows && b[4] === 0 && b[5] === 0) {
                

                this.loading = false

                this.data = response.data
                this.setupComponentData()
                
              } else if (a[6] === this.searchText && b[2] === this.currentPage && b[3] === this.rows && b[4] === 0 && b[5] === 0) {
                

                this.loading = false

                this.data = response.data
                this.setupComponentData()

              }
            })
            .catch(err => {
              this.loading = false
              
                    
              this.$toast.add({
                severity: "error",
                summary: "Error",
                detail: `Error while getting reports for rows 100000`,
                life: 5000,
              })
            })
          
        }
      }

    },
    setupComponentData() {
      

      if (this.groupedOnColumnIndex >= 0) {

        let sum = 0, sums = [], types = []

        for (let i = 0; i < this.data.length; i++) {

          // total sum of all the reports
          if (this.dbViewFields[this.groupedOnColumnIndex].applySum) {
            sum += this.data[i][this.dbViewFields[this.groupedOnColumnIndex].colField]
          }

          // separating types (number of groups)
          let index = types.findIndex(a => a === this.data[i][this.dbViewFields[this.groupedOnColumnIndex].colField])
          if (index < 0) {
            types.push(this.data[i][this.dbViewFields[this.groupedOnColumnIndex].colField])
            sums.push({})
          }
          index = types.findIndex(a => a === this.data[i][this.dbViewFields[this.groupedOnColumnIndex].colField])

          // 
          
          // taking sum in groups
          for (let j = 0; j < this.colSelectedFieldsForTable.length; j++) {

            // almost duplicate columns list without the column on which we are grouping

            if (i === 0 && this.colSelectedFieldsForTable[j].colField !== this.dbViewFields[this.groupedOnColumnIndex].colField) {
              this.colSelectedFieldsForTableWithoutGroupedOnColumn.push(this.   colSelectedFieldsForTable[j])
            }

            if (i === 0 || sums[index][this.colSelectedFieldsForTable[j].colField] === undefined) {
              if (this.colSelectedFieldsForTable[j].applySum) {
                sums[index][this.colSelectedFieldsForTable[j].colField] = 0
              } else {
                sums[index][this.colSelectedFieldsForTable[j].colField] = null
              }
            }

            if (j === 0) {
              sums[index][this.colSelectedFieldsForTable[j].colField] = `${this.data[i][this.dbViewFields[this.groupedOnColumnIndex].colField]} Totals`
            }

            if (
              typeof sums[index][this.colSelectedFieldsForTable[j].colField] === 'number'
            ) {

              sums[index][this.colSelectedFieldsForTable[j].colField] += this.data[i][this.colSelectedFieldsForTable[j].colField]
        
            }

          }
        }
        
        this.sum = sum
        this.groupSums = sums
      
        this.dbViewFields.forEach(field => {
          
          if (field.applySum) {
            let sum = 0
            this.groupSums.forEach(a => {
              sum += a[field.colField]
            })
            // totalsRow[field.colField] = sum
            this.sumSentences.push({
              text: `Total ${field.colName}: ${this.getToShow1(sum, field)} `,
              field
            })
          }
        })

        
        // this.groupSums.push(totalsRow)
        // types.push(this.totalGroupType)

        this.allGroupTypes = types
        this.expandedRowGroups = types

      }
    },
    onRowCollapse(e) {
      this.reloadGroupFooters++
    },
    onRowExpand(e) {
      this.reloadGroupFooters++
    },
    getGroupName(data, type) {
      // if (data[type.colField] !== this.totalGroupType) {
        return `${type.colName} : ${data[type.colField]}`;
      // } else {
      //   return data[type.colField]
      // }
    },
    calculateRecordsTotal(data, type) {
      let records = [];

      // if (data[type] !== this.totalGroupType) {
        if (data && type) {
          records = this.data.filter(a => a[type] === data[type])
        }

        return `(${records.length} row/s)`;
      // } else {
      //   return ''
      // }
    },
    getRecordsSum(data, col) {
      let index = this.allGroupTypes.findIndex(a => a === data[this.groupedOnColumn.colField])
      // 
      // if (data[this.groupedOnColumn.colField] === 'FAS') {
      //   
      // }
      if (index >= 0 &&  this.groupSums[index] && this.groupSums[index][col.colField]) {
        return this.getToShow1(this.groupSums[index][col.colField], col)
      } else {
        return ''
      }
    },
    setBordersOfSumsRow() {
      let a = document.getElementsByClassName('sum-present')
      // 
      if (a && a.length) {
        a.forEach((b, index) => {
          // b.style.borderWidth = '5px'
          b.style.borderBottomWidth = '5px'
          b.children[0].style.color ='white'
          b.children[0].style.padding ='5px'
          b.children[0].style.fontWeight ='bold'
          
          if (
            this.$store.getters['getActiveThemeColor']
          ) {
            // b.style.borderColor = this.$store.getters['getActiveThemeColor']
            b.children[0].style.backgroundColor = this.$store.getters['getActiveThemeColor']
          } else {
            // b.style.borderColor = 'black'
            b.children[0].style.backgroundColor = 'black'
          }
        })
      }
    },
    viewFullHistory() {
      if (this.tempCustomer && this.tempCustomer.customerId)
        this.$router.push({
          path: "/customers/" + this.tempCustomer.customerId + "/history",
          params: { custid: this.tempCustomer.customerId },
        });
    },
    viewCustomer() {
      if (this.tempCustomer && this.tempCustomer.customerId)
        this.$router.push({
          path: "/customers/" + this.tempCustomer.customerId + "/detail",
          params: { custid: this.tempCustomer.customerId },
        });
    },
    async toggle(event) {
      this.$refs.op.toggle(event);
    },
    openOP(data, col, event) {
      
      
      if (data && data.customerId && col.colField === 'custName') {
        this.tempCustomer = {
          custName: data.custName,
          customerId: data.customerId
        }
        this.customerHistory = []
        this.customerHistoryLoading = true
        this.customerService
          .getCustomerHistory(data.customerId)
          .then(data => {
            if (data.length > 20) {
              this.customerHistory = data.slice(0, 20);
            } else {
              this.customerHistory = data
            }
            this.customerHistoryLoading = false
          })
          .catch(err => {
            this.customerHistoryLoading = false
            // this.$toast.add({
            //   severity: "error",
            //   summary: "Error",
            //   detail: "Error while getting customer history.",
            //   life: 5000,
            // })
            this.$store.dispatch('addErrorMessage', {
              severity: 'error',
              content: 'Some data was not loaded from "getCustomerHistory/{customerId}"'
            })
          })
        this.toggle(event);
      }
    },
    getStyle1(data, col) {
      if (
        col.colField === 'quoteVer' ||
        col.colField === 'custName'
      ) {
        return 'under_lined'
      }
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    getToShow(data, col) {
      let b = data[col.colField]

      // 

      if (
        b !== null 
        && b !== undefined
      ) {

        if (
          col.colType === "Currency"
        ) {
          try {
              
            return formatCurrency(b, { emptyAsBlank: true })

          } catch (e) {
            return b
          }
        } else if (col.colType === 'Number') {
          
          try {
            let c = b.toString().split('.')
            // 

            if (c[0]) {
              let d = c[0].split(',')
              if (d.length < 2) {
                c[0] = this.numberWithCommas(c[0])
              }
            }

            return `${c[0]}`

          } catch (e) {
            return b
          }

        } else {
          return b
        }
        
      } else {
        return ''
      }
    },
    getToShow1(data, col) {
      let b = data

      // 

      if (
        b !== null 
        && b !== undefined
      ) {

        if (
          col.colType === "Currency"
        ) {
          try {
              
            return formatCurrency(b, { emptyAsBlank: true })

          } catch (e) {
            return b
          }
        } else if (col.colType === 'Number') {
          
          try {
            let c = b.toString().split('.')
            // 

            if (c[0]) {
              let d = c[0].split(',')
              if (d.length < 2) {
                c[0] = this.numberWithCommas(c[0])
              }
            }

            return `${c[0]}`

          } catch (e) {
            return b
          }

        } else {
          return b
        }
        
      } else {
        return ''
      }
    },
    colsResized(event) {
      // 
      
      if (
        event.element && 
        event.element.clientWidth &&
        event.element.textContent
      ) {
        let e = event.element.clientWidth, b = this.colSelectedFieldsForTable.findIndex(a => a.colName === event.element.outerText)
        // 
        
        if (b > -1) {
          let c = [...this.colSelectedFieldsForTable]
          c[b].colWidth = e

          this.$emit('colsUpdated', c)
        }
      }
    },
    getFooterPosition({ text, field }) {
      let space = 0
      for (let i = 0; i < this.colSelectedFieldsForTable.length; i++) {
        if (this.colSelectedFieldsForTable[i].colField === field.colField) {
          break
        }
        space += this.colSelectedFieldsForTable[i].colWidth
      }
      space -= 140
      return 'position: absolute; margin-left: ' + space + 'px; '
    },
    // getFooterPosition(obj, index) {
    //   return 'position: absolute; margin-left: ' + index * 200 + 'px; '
    // }
  }
}
</script>

<style>

</style>